export enum ProjectType {
  'expertise_et_conseil' = 'Expertise & conseil',
  'direction_de_project' = 'Direction de projet',
  'gestion_de_projet_it' = 'Gestion de projet IT',
  'transformation_digitale' = 'Transformation digitale',
  'formation/coaching' = 'Formation/coaching',
  'audit_rh/sirh' = 'Audit RH/SIRH',
}


export enum SectorType {
  'industrie' = 'Industrie',
  'finance' = 'Finance',
  'technologie' = 'Technologie',
}

export interface IUser {
  _id: string;
  firstname: string;
  lastname: string;
  email: string;
  roles: string[];
  address: {
    phone: string;
    mobilephone: string;
    address1: string;
    address2: string;
    zipcode: string;
    city: string;
  };
  company: {
    address1: string;
    address2: string;
    companyCode: string;
    companyName: string;
    zipcode: string;
    city: string;
  };
  meta: {
    creationDate: Date;
    deactivationReason: string;
    lastModified: Date;
    status: 'registration' | 'initial' | 'active' | 'inactive';
  };
  type: 'client' | 'consultant';
  profile: {
    dailyPriceMin: string;
    dailyPriceMax: string;
    certification: ICertification[];
    experience: IExperience[];
    description: string;
    education: IEducation[];
    picture: {
      filename: string;
      pictureUrl: string;
      uuid: string;
    };
    projectType: ProjectType[];
    resume: {
      filename: string;
      resumeUrl: string;
      uuid: string;
    };
    // sector1: SectorType;
    // sector2: SectorType;
    // sector3: SectorType;
    sector:[
      {
        value: string;
        label: string
      }
    ] ;
    functionalSkills:[
      {
        value: string;
        label: string
      }
    ] ;
    technicalSkills: [
      {
        value: string;
        label: string
      }
    ] ;
    isAvailable: boolean;
    availableDate: any;
    title: string;
  };
  projectList: string[];
}

export interface IFile {
  filename: string;
  uuid: string;
}

export interface IExperience
    {
      title: string;
      company: string;
      startDate: any;
      endDate: any;
      description: string;
    }

export interface IEducation
{
  school: string;
  title: string;
  startDate: any;
  endDate: any;
}

export interface ICertification
{
  title: string;
  obtainDate: any;
}


export interface IProject {
  _id: string;
  budgetMax?: string;
  budgetMin?: string;
  clientId: string;
  currency: 'EUR';
  dailyPriceMax?: string;
  dailyPriceMin?: string;
  deliverable?: [{ value: string; label: string; }]; // string
  description: string;
  duration?:[{ value: string; label: string}] ; // number;
  estimatedEndDate?: Date;
  files: IFile[];
  localisation: {
    label: string;
    location: { lat: number; lng: number };
  };
  meta: {
    creationDate: Date;
    lastModified: Date;
    status: 'hidden' | 'initial' | 'validated' | 'started' | 'ended' | 'canceled' ;
  };
  notification: boolean;
  phone?: string;
  place: [{ value: string; label: string;}]; // 'Forfait' | 'Régie';
  projectType: ProjectType[];
  proposition: IProposition;
  propositionList: IProposition[];
  functionalSkills?: [{ value: string; label: string; }] ; // string;
  technicalSkills?: [{ value: string; label: string; }] ; // string;
  startingDate?: Date;
  subtype?: [{ value: string; label: string; }] ; // string;
  title: string;
}

export interface ILoginResponse {
  acessToken: string;
  accessTokenExpiration: number;
  user: IUser;
}

export interface IMessage {
  creationDate: Date;
  receiver: string;
  sender: string;
  text: string;
}

export interface INotation {
  label: string;
  notation: 1 | 2 | 3 | 4 | 5;
}

export interface IProposition {
  _id: string;
  appliedRate: number;
  choosingDate: Date;
  consultantId: string;
  currency: 'EUR';
  dailyPrice: number;
  description: string;
  estimatedEndDate: Date;
  evaluation: {
    comments: string;
    evaluationDate: Date;
    notationList: INotation[];
  };
  files: IFile[];
  finalDailyPrice: number;
  finalPrice: number;
  messageList: IMessage[];
  meta: {
    creationDate: Date;
    lastModified: Date;
    status:
      | 'hidden'
      | 'initial'
      | 'expired'
      | 'rejected'
      | 'sent'
      | 'validated'
      | 'refused'
      | 'shortlisted'
      | 'accepted'
  };
  notification: boolean;
  price: number;
  project: IProject;
  sendingDate: Date;
  startingDate: Date;
  stepList: IStep[];
  title: string;
  validationDate: Date;
  vat: number;
}

export interface IStep {
  _id: string;
  description: string;
  estimatedEndDate: Date;
  meta: {
    creationDate: Date;
    lastModified: Date;
    status: 'initial' | 'started' | 'validated';
  };
  propositionId: string;
  startingDate: Date;
  stepNumber: number;
  title: string;
}



// WEBPACK FOOTER //
// ./src/model/index.ts